import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { Container } from './styles';

interface FollowupBiddingModalProps {
  showModalFollowup: boolean;
  setShowModalFollowup: React.Dispatch<React.SetStateAction<boolean>>;
  followup: any;
}

const FollowupBiddingModal: React.FC<FollowupBiddingModalProps> = ({
  showModalFollowup,
  setShowModalFollowup,
  followup,
}) => {
  return (
    <Modal show={showModalFollowup} size="xl" aria-labelledby="contained-modal-title-vcenter">
      <Container>
        <div className="modal-content">
          <div className="modal-header text-white">
            <h5 className="modal-title">Acompanhamentos ({followup?.length})</h5>
            <button
              type="button"
              className="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowModalFollowup(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div id="accordion">
              {followup?.map((item: any, index: number) => {
                const collapseId = `collapse-${index}`;
                const headingId = `heading-${index}`;
                const isFirst = index === 0;

                return (
                  <div className="card mt-3">
                    <div className="card-header" id={headingId}>
                      <p className="mb-0">
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div>
                            <strong>Data:</strong> {moment(item?.data_fonte).format('DD/MM/YYYY')}
                          </div>
                          <div>
                            <strong>Nº ConLicitação:</strong> {item?.id}
                          </div>
                          <button
                            className="btn btn-link text-dark p-0 ml-3"
                            type="button"
                            data-toggle="collapse"
                            data-target={`#${collapseId}`}
                            aria-expanded={isFirst}
                            aria-controls={collapseId}
                          >
                            <span className="oi oi-chevron-bottom" />
                          </button>
                        </div>
                      </p>
                    </div>

                    <div
                      id={collapseId}
                      className={`collapse ${isFirst ? 'show' : ''}`}
                      aria-labelledby={headingId}
                      data-parent="#accordion"
                    >
                      <div className="card-body">{item?.sintese}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};
export default FollowupBiddingModal;
